(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-newsletter-overlay]').forEach(function (overlay) {
    /* Dismiss button */
    overlay.querySelectorAll('[data-newsletter-dismiss]').forEach(function (control) {
      control.addEventListener('click', function () {
        overlay.classList.add('is-dismissed');
      });
    });

    /* Mailchimp AJAX submission */
    var form = overlay.querySelector('[data-mc-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      var email = encodeURIComponent(emailInput.value.trim());
      var callbackName = '__mc_cb_' + Date.now();
      var mcURL = 'https://nonathelabel.us14.list-manage.com/subscribe/post-json?u=3c1a44ef572a230b39fb23eee&id=6e2a76c6dc&f_id=004a40e5f0&EMAIL=' + email + '&c=' + callbackName;

      var successEl = form.querySelector('[data-mc-success]');
      var errorEl = form.querySelector('[data-mc-error]');
      var fieldsEl = form.querySelector('[data-mc-fields]');

      /* Hide any previous messages */
      successEl.style.display = 'none';
      errorEl.style.display = 'none';

      /* JSONP callback */
      window[callbackName] = function (resp) {
        if (resp && resp.result === 'success') {
          successEl.style.display = 'block';
          fieldsEl.style.display = 'none';
        } else if (resp && resp.result === 'error' && resp.msg && resp.msg.indexOf('already subscribed') > -1) {
          /* Already subscribed counts as success */
          successEl.style.display = 'block';
          fieldsEl.style.display = 'none';
        } else {
          errorEl.style.display = 'block';
        }
        /* Cleanup */
        delete window[callbackName];
      };

      /* Inject JSONP script */
      var script = document.createElement('script');
      script.src = mcURL;
      script.onerror = function () {
        errorEl.style.display = 'block';
        delete window[callbackName];
      };
      document.body.appendChild(script);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-collection-gallery"]) return;
  try {
    
  (function () {
    var galleryPage = document.querySelector('[data-header-collection-gallery-page]');
    if (!galleryPage) {
      return;
    }

    var galleryId = new URLSearchParams(window.location.search).get('gallery');
    var galleryTemplate = null;

    document.querySelectorAll('template[data-header-collection-gallery]').forEach(function (template) {
      if (template.dataset.headerCollectionGallery === galleryId) {
        galleryTemplate = template;
      }
    });

    if (!galleryTemplate) {
      var emptyMessage = document.createElement('p');
      emptyMessage.className = 'press-page__empty';
      emptyMessage.textContent = galleryPage.dataset.emptyMessage || '';
      galleryPage.appendChild(emptyMessage);
      return;
    }

    var title = document.createElement('h1');
    title.className = 'visually-hidden';
    title.textContent = galleryTemplate.dataset.headerCollectionTitle || '';
    galleryPage.appendChild(title);
    galleryPage.appendChild(galleryTemplate.content.cloneNode(true));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var headerShell = document.querySelector('.header-shell');
    var fullMenu = document.querySelector('[data-header-fullmenu]');
    var fullMenuToggle = document.querySelector('[data-header-fullmenu-toggle]');
    var shopMenu = document.querySelector('[data-header-shop-menu]');
    var shopOpenBtn = document.querySelector('[data-header-shop-open]');
    var shopCloseBtn = shopMenu ? shopMenu.querySelector('[data-header-shop-close]') : null;
    var shopSurface = shopMenu ? shopMenu.querySelector('[data-shop-menu-surface]') : null;
    var shopDismiss = shopMenu ? shopMenu.querySelector('[data-shop-menu-dismiss]') : null;

    function syncHeaderStripLinks() {
      if (!headerShell) {
        return;
      }

      var infoUrl = headerShell.dataset.informationUrl;
      if (!infoUrl) {
        return;
      }

      document.querySelectorAll('.header-strip a.header-strip__link').forEach(function (link) {
        link.setAttribute('href', infoUrl);
      });
    }

    syncHeaderStripLinks();

    function ensureFullMenuPortal() {
      if (fullMenu && fullMenu.parentElement !== document.body) {
        document.body.appendChild(fullMenu);
      }
    }

    ensureFullMenuPortal();

    function resetFullMenuCollections() {
      var fullMenuNav = fullMenu ? fullMenu.querySelector('[data-header-fullmenu-nav]') : null;
      var collectionsToggle = fullMenu ? fullMenu.querySelector('[data-header-fullmenu-collections-toggle]') : null;
      if (fullMenuNav) {
        fullMenuNav.classList.remove('header-fullmenu__nav--collections-expanded');
      }
      if (collectionsToggle) {
        collectionsToggle.setAttribute('aria-expanded', 'false');
      }
    }

    function toggleFullMenuCollections(collectionsToggle) {
      var fullMenuNav = fullMenu ? fullMenu.querySelector('[data-header-fullmenu-nav]') : null;
      if (!fullMenuNav || !collectionsToggle) {
        return;
      }

      var isExpanded = fullMenuNav.classList.toggle('header-fullmenu__nav--collections-expanded');
      collectionsToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    function setShopExpanded(isOpen) {
      if (!shopOpenBtn) {
        return;
      }
      shopOpenBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function setFullMenuExpanded(isOpen) {
      if (headerShell) {
        headerShell.classList.toggle('header-shell--fullmenu-open', isOpen);
      }
      document.body.classList.toggle('header-fullmenu-open', isOpen);
      if (fullMenuToggle) {
        fullMenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }

    function closeShopMenu() {
      if (shopMenu && shopMenu.open) {
        shopMenu.close();
      }
      setShopExpanded(false);
    }

    function openShopMenu() {
      closeFullMenu();
      if (shopMenu) {
        if (shopMenu.show) {
          shopMenu.show();
        } else if (shopMenu.showModal) {
          shopMenu.showModal();
        }
        setShopExpanded(true);
      }
    }

    function closeFullMenu() {
      if (fullMenu && fullMenu.open && fullMenu.close) {
        fullMenu.close();
      }
      resetFullMenuCollections();
      setFullMenuExpanded(false);
    }

    function openFullMenu() {
      closeShopMenu();
      if (fullMenu) {
        ensureFullMenuPortal();
        if (fullMenu.show) {
          fullMenu.show();
        } else if (fullMenu.showModal) {
          fullMenu.showModal();
        }
        setFullMenuExpanded(true);
        window.requestAnimationFrame(function () {
          if (fullMenuToggle) {
            fullMenuToggle.focus({ preventScroll: true });
          }
        });
      }
    }

    function toggleFullMenu() {
      if (fullMenu && fullMenu.open) {
        closeFullMenu();
      } else {
        openFullMenu();
      }
    }

    if (shopOpenBtn) {
      shopOpenBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (shopMenu && shopMenu.open) {
          closeShopMenu();
        } else {
          openShopMenu();
        }
      });
    }

    if (shopCloseBtn) {
      shopCloseBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closeShopMenu();
      });
    }

    if (shopDismiss) {
      shopDismiss.addEventListener('click', function (event) {
        event.preventDefault();
        closeShopMenu();
      });
    }

    if (shopSurface) {
      shopSurface.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    if (shopMenu) {
      shopMenu.addEventListener('click', function (event) {
        if (event.target === shopMenu || event.target === shopDismiss) {
          closeShopMenu();
        }
      });

      shopMenu.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeShopMenu();
      });

      shopMenu.addEventListener('close', function () {
        setShopExpanded(false);
      });
    }

    if (fullMenuToggle) {
      fullMenuToggle.addEventListener('click', function (event) {
        event.preventDefault();
        toggleFullMenu();
      });
    }

    if (fullMenu) {
      fullMenu.addEventListener('close', function () {
        resetFullMenuCollections();
        setFullMenuExpanded(false);
      });

      fullMenu.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeFullMenu();
      });

      fullMenu.addEventListener('click', function (event) {
        if (!event.target.closest('.header-fullmenu__surface')) {
          closeFullMenu();
          return;
        }

        var collectionsToggle = event.target.closest('[data-header-fullmenu-collections-toggle]');
        if (collectionsToggle) {
          event.preventDefault();
          event.stopPropagation();
          toggleFullMenuCollections(collectionsToggle);
          return;
        }

        if (event.target.closest('a.header-fullmenu__link')) {
          closeFullMenu();
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (shopMenu && shopMenu.open) {
        if (
          !event.target.closest('[data-shop-menu-surface]') &&
          !event.target.closest('[data-header-shop-open]')
        ) {
          closeShopMenu();
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeShopMenu();
        closeFullMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var host = document.querySelector('product-recommendations.product-recommendations__host');
    if (!host || !host.dataset.url) {
      return;
    }

    var loaded = false;

    function loadRecommendations() {
      if (loaded) {
        return;
      }
      loaded = true;

      fetch(host.dataset.url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('recommendations failed');
          }
          return response.text();
        })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var fetched = html.querySelector('product-recommendations');
          if (!fetched) {
            return;
          }

          var grid = fetched.querySelector('.product-row__grid');
          if (!grid) {
            return;
          }

          var cards = grid.querySelectorAll('.product-card');
          if (cards.length < 4) {
            return;
          }

          host.innerHTML = fetched.innerHTML;
        })
        .catch(function () {
          loaded = false;
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) {
            return;
          }
          observer.disconnect();
          loadRecommendations();
        },
        { rootMargin: '0px 0px 200px 0px' }
      );
      observer.observe(host);
    } else {
      loadRecommendations();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProductPage() {
    var dataEl = document.querySelector('[data-product-page-data]');
    var form = document.querySelector('[data-product-form]');
    if (!dataEl || !form) {
      return;
    }

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (parseError) {
      return;
    }

    if (!data.variants || !data.variants.length) {
      return;
    }
    var variantIdInput = form.querySelector('[data-variant-id]');
    var quantityInput = form.querySelector('[data-product-quantity]');
    var priceAmountEl = document.querySelector('[data-product-price-amount]');
    var addBtn = form.querySelector('[data-product-add]');
    var plusBtn = form.querySelector('[data-product-quantity-plus]');
    var mediaScroller = document.querySelector('[data-product-media-inner]');
    var selectedSwatch = document.querySelector('[data-product-selected-swatch]');
    var selectedColourName = document.querySelector('[data-product-selected-colour]');
    var sizeToggle = form.querySelector('[data-product-size-toggle]');
    var sizeToggleLabel = form.querySelector('[data-product-size-toggle-label]');
    var sizePanel = form.querySelector('[data-product-size-panel]');

    function isMobilePurchase() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function setSizePanelOpen(isOpen) {
      if (!sizePanel || !sizeToggle) {
        return;
      }
      if (!isMobilePurchase()) {
        sizePanel.hidden = false;
        sizeToggle.setAttribute('aria-expanded', 'false');
        sizeToggle.classList.remove('is-open');
        return;
      }
      sizePanel.hidden = !isOpen;
      sizeToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      sizeToggle.classList.toggle('is-open', isOpen);
    }

    function updateSizeToggleLabel() {
      if (!sizeToggleLabel) {
        return;
      }
      var defaultLabel = sizeToggleLabel.getAttribute('data-default-label') || '';
      sizeToggleLabel.textContent = selection.size || defaultLabel;
    }

    var colorSwatch = window.NonaColorSwatch || {};
    var colorStyle = colorSwatch.colorStyle || function () {
      return 'background-color: #e8e4dc;';
    };
    var applySwatch = colorSwatch.applySwatch || function (el, colorName) {
      if (!el) {
        return;
      }
      var hex = el.getAttribute('data-swatch-hex');
      var fill = colorSwatch.colorValue
        ? colorSwatch.colorValue(colorName, hex)
        : '#e8e4dc';
      el.style.setProperty('--swatch-fill', fill);
    };

    function swatchFillForColor(colorName) {
      var fill = null;

      form.querySelectorAll('[data-product-colour]').forEach(function (btn) {
        if (fill || btn.getAttribute('data-value') !== colorName) {
          return;
        }

        var swatchEl = btn.querySelector('.product-page__swatch');
        if (!swatchEl) {
          return;
        }

        fill = swatchEl.style.getPropertyValue('--swatch-fill');
        if (!fill || !fill.trim()) {
          fill = getComputedStyle(swatchEl).getPropertyValue('--swatch-fill');
        }

        if (!fill || !fill.trim()) {
          var hex = swatchEl.getAttribute('data-swatch-hex');
          if (hex && colorSwatch.colorValue) {
            fill = colorSwatch.colorValue(colorName, hex);
          }
        }
      });

      return fill && fill.trim() ? fill.trim() : null;
    }

    function applySelectedSwatch(colorName) {
      if (!selectedSwatch || !colorName) {
        return;
      }

      var fill = swatchFillForColor(colorName);
      var matchedHex = null;

      form.querySelectorAll('[data-product-colour]').forEach(function (btn) {
        if (btn.getAttribute('data-value') !== colorName) {
          return;
        }
        var swatchEl = btn.querySelector('.product-page__swatch');
        if (swatchEl) {
          matchedHex = swatchEl.getAttribute('data-swatch-hex');
        }
      });

      if (!fill) {
        var hex = matchedHex || selectedSwatch.getAttribute('data-swatch-hex');
        if (colorSwatch.colorValue) {
          fill = colorSwatch.colorValue(colorName, hex);
        }
      }

      if (fill) {
        selectedSwatch.style.setProperty('--swatch-fill', fill);
      }

      if (matchedHex) {
        selectedSwatch.setAttribute('data-swatch-hex', matchedHex);
      } else {
        selectedSwatch.removeAttribute('data-swatch-hex');
      }
    }

    var selection = {
      color: null,
      size: null
    };

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && data.moneyFormat) {
        return window.Shopify.formatMoney(cents, data.moneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function optionValue(variant, position) {
      if (position === 1) {
        return variant.option1;
      }
      if (position === 2) {
        return variant.option2;
      }
      if (position === 3) {
        return variant.option3;
      }
      return null;
    }

    function findVariant() {
      return data.variants.find(function (variant) {
        if (data.colorOptionPosition && selection.color) {
          if (optionValue(variant, data.colorOptionPosition) !== selection.color) {
            return false;
          }
        }
        if (data.sizeOptionPosition && selection.size) {
          if (optionValue(variant, data.sizeOptionPosition) !== selection.size) {
            return false;
          }
        }
        return true;
      });
    }

    function mediaById(id) {
      return data.media.find(function (entry) {
        return entry.id === id;
      });
    }

    function isMobileMediaGallery() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function scrollToMedia(mediaId) {
      if (!mediaId || !mediaScroller) {
        return;
      }
      var slide = mediaScroller.querySelector(
        '[data-product-media-slide][data-media-id="' + mediaId + '"]'
      );
      if (!slide) {
        return;
      }

      if (isMobileMediaGallery()) {
        var targetLeft =
          slide.getBoundingClientRect().left -
          mediaScroller.getBoundingClientRect().left +
          mediaScroller.scrollLeft;

        if (Math.abs(mediaScroller.scrollLeft - targetLeft) < 1) {
          updateMediaDots(mediaId);
          return;
        }

        mediaScroller.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
        updateMediaDots(mediaId);
        return;
      }

      var headerOffset = 0;
      var pagePad = getComputedStyle(document.documentElement).getPropertyValue(
        '--page-content-padding'
      );
      if (pagePad) {
        headerOffset = parseFloat(pagePad) || 0;
      }

      var slideTop = slide.getBoundingClientRect().top + window.scrollY - headerOffset;
      if (Math.abs(window.scrollY - slideTop) < 2) {
        return;
      }

      window.scrollTo({
        top: Math.max(0, slideTop),
        behavior: 'smooth',
      });
    }

    function updateMediaDots(activeMediaId) {
      var dots = document.querySelectorAll('[data-product-media-dot]');
      if (!dots.length) {
        return;
      }

      dots.forEach(function (dot) {
        var isActive = dot.getAttribute('data-media-id') === String(activeMediaId);
        dot.classList.toggle('is-active', isActive);
      });
    }

    function syncMediaDotsFromScroll() {
      if (!mediaScroller || !isMobileMediaGallery()) {
        return;
      }

      var slides = mediaScroller.querySelectorAll('[data-product-media-slide]');
      if (!slides.length) {
        return;
      }

      var scrollerLeft = mediaScroller.getBoundingClientRect().left;
      var closestSlide = slides[0];
      var closestDistance = Infinity;

      slides.forEach(function (slide) {
        if (slide.hidden || slide.classList.contains('is-color-hidden')) {
          return;
        }
        var distance = Math.abs(slide.getBoundingClientRect().left - scrollerLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });

      if (closestSlide) {
        updateMediaDots(closestSlide.getAttribute('data-media-id'));
      }
    }

    var mediaScrollTicking = false;

    function onMediaScroll() {
      if (mediaScrollTicking) {
        return;
      }

      mediaScrollTicking = true;
      window.requestAnimationFrame(function () {
        syncMediaDotsFromScroll();
        mediaScrollTicking = false;
      });
    }

    function updateVariantUI(variant) {
      if (!variant) {
        return;
      }

      variantIdInput.value = variant.id;
      if (priceAmountEl) {
        priceAmountEl.textContent = formatMoney(variant.price);
      }
      if (addBtn) {
        addBtn.textContent = variant.available
          ? addBtn.dataset.labelAvailable
          : addBtn.dataset.labelSoldOut;
      }
      updateActionButtons(variant);

      /* Desktop: page scroll owns the gallery — don't jump to media on colour change. */
      if (!isMobileMediaGallery()) {
        return;
      }

      if (variant.featured_media && variant.featured_media.id) {
        scrollToMedia(variant.featured_media.id);
      } else if (variant.featured_image && variant.featured_image.src) {
        var match = data.media.find(function (entry) {
          return entry.src === variant.featured_image.src;
        });
        if (match) {
          scrollToMedia(match.id);
        }
      }
    }

    function syncCartProperties() {
      var colorProp = form.querySelector('[data-product-property-color]');
      var sizeProp = form.querySelector('[data-product-property-size]');
      if (colorProp) {
        if (selection.color) {
          colorProp.value = selection.color;
          colorProp.disabled = false;
        } else {
          colorProp.disabled = true;
        }
      }
      if (sizeProp) {
        if (selection.size) {
          sizeProp.value = selection.size;
          sizeProp.disabled = false;
        } else {
          sizeProp.value = '';
          sizeProp.disabled = true;
        }
      }
    }

    function refreshSizeAvailability() {
      if (!data.sizeOptionPosition) {
        return;
      }
      form.querySelectorAll('[data-product-size]').forEach(function (btn) {
        var sizeValue = btn.getAttribute('data-value');
        var available = data.variants.some(function (variant) {
          if (!variant.available) {
            return false;
          }
          if (data.colorOptionPosition && selection.color) {
            if (optionValue(variant, data.colorOptionPosition) !== selection.color) {
              return false;
            }
          }
          return optionValue(variant, data.sizeOptionPosition) === sizeValue;
        });
        btn.disabled = !available;
      });
    }

    function setActiveButtons(selector, activeValue) {
      form.querySelectorAll(selector).forEach(function (btn) {
        var isActive = btn.getAttribute('data-value') === activeValue;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function variantIdEquals(a, b) {
      return Number(a) === Number(b);
    }

    function initSelectionFromVariant() {
      var currentId = parseInt(variantIdInput.value, 10);
      var current = data.variants.find(function (v) {
        return variantIdEquals(v.id, currentId);
      });
      if (!current) {
        current = data.variants[0];
      }
      if (data.colorOptionPosition) {
        selection.color = optionValue(current, data.colorOptionPosition);
      }
      if (data.sizeOptionPosition) {
        selection.size = optionValue(current, data.sizeOptionPosition);
      }
      if (!selection.color) {
        var firstColour = form.querySelector('[data-product-colour]');
        if (firstColour) {
          selection.color = firstColour.getAttribute('data-value');
        }
      }
    }

    function normalizeColorLabel(value) {
      if (window.NonaColorMedia && window.NonaColorMedia.normalizeColorLabel) {
        return window.NonaColorMedia.normalizeColorLabel(value);
      }
      return String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function altMatchesColor(alt, color) {
      if (window.NonaColorMedia && window.NonaColorMedia.altMatchesColor) {
        return window.NonaColorMedia.altMatchesColor(alt, color);
      }
      var normalizedAlt = normalizeColorLabel(alt);
      var normalizedColor = normalizeColorLabel(color);
      if (!normalizedAlt || !normalizedColor) {
        return false;
      }
      if (normalizedAlt === normalizedColor) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + ' /') === 0) {
        return true;
      }
      if (normalizedAlt.indexOf(normalizedColor + '/') === 0) {
        return true;
      }
      var parts = normalizedAlt.split(/\s*\/\s*/);
      for (var i = 0; i < parts.length; i++) {
        if (parts[i] === normalizedColor) {
          return true;
        }
      }
      return false;
    }

    function mediaIdsFromMap(color) {
      if (!color || !data.colorMediaIds) {
        return [];
      }
      var direct = data.colorMediaIds[color];
      if (direct && direct.length) {
        return direct.map(String);
      }
      var want = normalizeColorLabel(color);
      var keys = Object.keys(data.colorMediaIds);
      for (var i = 0; i < keys.length; i++) {
        if (normalizeColorLabel(keys[i]) === want && data.colorMediaIds[keys[i]].length) {
          return data.colorMediaIds[keys[i]].map(String);
        }
      }
      return [];
    }

    function mediaIdsForColor(color) {
      if (!color) {
        return [];
      }

      var mapped = mediaIdsFromMap(color);
      if (mapped.length) {
        return mapped;
      }

      var ids = [];
      var seen = {};

      function addId(id) {
        if (id == null || id === '') {
          return;
        }
        var key = String(id);
        if (seen[key]) {
          return;
        }
        seen[key] = true;
        ids.push(key);
      }

      if (data.media && data.media.length) {
        data.media.forEach(function (entry) {
          if (altMatchesColor(entry.alt, color)) {
            addId(entry.id);
          }
        });
      }

      document.querySelectorAll('[data-product-media-slide]').forEach(function (slide) {
        if (slide.classList.contains('product-page__media-slide--empty')) {
          return;
        }
        if (altMatchesColor(slide.getAttribute('data-media-alt'), color)) {
          addId(slide.getAttribute('data-media-id'));
        }
      });

      if (data.variants && data.variants.length) {
        data.variants.forEach(function (variant) {
          var variantColor = data.colorOptionPosition
            ? optionValue(variant, data.colorOptionPosition)
            : null;
          var isColorMatch =
            (variantColor && normalizeColorLabel(variantColor) === normalizeColorLabel(color)) ||
            altMatchesColor(variant.option1, color) ||
            altMatchesColor(variant.option2, color) ||
            altMatchesColor(variant.option3, color) ||
            altMatchesColor(variant.title, color);

          if (!isColorMatch) {
            return;
          }

          if (variant.featured_media && variant.featured_media.id != null) {
            addId(variant.featured_media.id);
          }

          if (variant.featured_image && data.media) {
            var featuredSrc = String(variant.featured_image.src || '');
            data.media.forEach(function (entry) {
              if (altMatchesColor(entry.alt, color)) {
                addId(entry.id);
              }
              if (
                featuredSrc &&
                entry.src &&
                (entry.src === featuredSrc ||
                  String(entry.src).split('?')[0] === featuredSrc.split('?')[0])
              ) {
                addId(entry.id);
              }
              if (
                variant.featured_image.alt &&
                altMatchesColor(entry.alt, variant.featured_image.alt)
              ) {
                addId(entry.id);
              }
            });
          }
        });
      }

      return ids;
    }

    function filterMediaByColor(color, options) {
      var opts = options || {};
      var shouldScroll = opts.scroll === true;
      var slides = Array.prototype.slice.call(
        document.querySelectorAll('[data-product-media-slide]')
      ).filter(function (slide) {
        return !slide.classList.contains('product-page__media-slide--empty');
      });
      var dots = document.querySelectorAll('[data-product-media-dot]');
      if (!slides.length) {
        return;
      }

      var colorIds = mediaIdsForColor(color);
      var shouldFilter = Boolean(color) && colorIds.length > 0;

      slides.forEach(function (slide) {
        var id = String(slide.getAttribute('data-media-id'));
        var match = !shouldFilter || colorIds.indexOf(id) !== -1;
        slide.hidden = !match;
        slide.classList.toggle('is-color-hidden', !match);
        slide.style.display = match ? '' : 'none';
      });

      dots.forEach(function (dot) {
        var id = String(dot.getAttribute('data-media-id'));
        var match = !shouldFilter || colorIds.indexOf(id) !== -1;
        dot.hidden = !match;
        dot.style.display = match ? '' : 'none';
      });

      var firstVisible = null;
      var visibleCount = 0;
      slides.forEach(function (slide) {
        if (!slide.hidden) {
          visibleCount += 1;
          if (!firstVisible) {
            firstVisible = slide;
          }
        }
      });

      /* Never leave an empty gallery if matching failed somehow. */
      if (shouldFilter && visibleCount === 0) {
        slides.forEach(function (slide) {
          slide.hidden = false;
          slide.classList.remove('is-color-hidden');
          slide.style.display = '';
          if (!firstVisible) {
            firstVisible = slide;
          }
        });
        dots.forEach(function (dot) {
          dot.hidden = false;
          dot.style.display = '';
        });
      }

      if (!firstVisible) {
        return;
      }

      updateMediaDots(firstVisible.getAttribute('data-media-id'));

      if (!shouldScroll) {
        return;
      }

      if (isMobileMediaGallery() && mediaScroller) {
        var targetLeft =
          firstVisible.getBoundingClientRect().left -
          mediaScroller.getBoundingClientRect().left +
          mediaScroller.scrollLeft;
        mediaScroller.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth',
        });
        return;
      }

      var headerOffset = 0;
      var pagePad = getComputedStyle(document.documentElement).getPropertyValue(
        '--page-content-padding'
      );
      if (pagePad) {
        headerOffset = parseFloat(pagePad) || 0;
      }
      var slideTop = firstVisible.getBoundingClientRect().top + window.scrollY - headerOffset;
      if (Math.abs(window.scrollY - slideTop) > 8) {
        window.scrollTo({
          top: Math.max(0, slideTop),
          behavior: 'smooth',
        });
      }
    }

    function applySelection(options) {
      var opts = options || {};
      if (selection.color) {
        setActiveButtons('[data-product-colour]', selection.color);
        applySelectedSwatch(selection.color);
        if (selectedColourName) {
          selectedColourName.textContent = selection.color;
        }
      }

      filterMediaByColor(selection.color, { scroll: opts.scrollMedia === true });

      if (selection.size) {
        setActiveButtons('[data-product-size]', selection.size);
      }

      updateSizeToggleLabel();
      refreshSizeAvailability();

      var variant = findVariant();
      if (!variant && data.sizeOptionPosition && !selection.size) {
        variant = data.variants.find(function (v) {
          if (data.colorOptionPosition && selection.color) {
            return optionValue(v, data.colorOptionPosition) === selection.color;
          }
          return true;
        });
      }

      if (!variant) {
        var currentId = parseInt(variantIdInput.value, 10);
        variant = data.variants.find(function (v) {
          return variantIdEquals(v.id, currentId);
        });
      }
      if (!variant) {
        variant = data.variants[0];
      }

      updateVariantUI(variant);
      syncCartProperties();
    }

    function paintSwatches() {
      form.querySelectorAll('[data-swatch-color]').forEach(function (el) {
        if (el === selectedSwatch) {
          return;
        }
        if (el.style.getPropertyValue('--swatch-fill')) {
          return;
        }
        applySwatch(el, el.getAttribute('data-swatch-color'));
      });
      if (selectedSwatch && selection.color) {
        applySelectedSwatch(selection.color);
      }
    }

    initSelectionFromVariant();
    applySelection();
    paintSwatches();
    setSizePanelOpen(false);

    window.addEventListener('resize', function () {
      setSizePanelOpen(false);
    });

    if (mediaScroller) {
      mediaScroller.addEventListener('scroll', onMediaScroll, { passive: true });
    }

    document.querySelectorAll('[data-product-media-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToMedia(dot.getAttribute('data-media-id'));
      });
    });

    var adding = false;

    function rootPath() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    function selectedVariant() {
      var variant = findVariant();
      if (!variant) {
        var currentId = parseInt(variantIdInput.value, 10);
        variant = data.variants.find(function (v) {
          return variantIdEquals(v.id, currentId);
        });
      }
      return variant;
    }

    function needsSizeSelection() {
      return Boolean(
        data.requireSize && form.querySelector('[data-product-size]') && !selection.size
      );
    }

    function canAddToCart() {
      syncCartProperties();
      if (needsSizeSelection()) {
        return false;
      }
      var variant = selectedVariant();
      return Boolean(variant && variant.available);
    }

    function updateActionButtons(variant) {
      if (!variant) {
        variant = selectedVariant();
      }
      var disable = adding || !variant || !variant.available;
      if (addBtn) {
        addBtn.disabled = disable;
      }
      if (plusBtn) {
        plusBtn.disabled = disable;
      }
    }

    function buildCartItem(quantity) {
      var variant = selectedVariant();
      if (!variant) {
        return null;
      }

      var item = {
        id: parseInt(variant.id, 10),
        quantity: Math.max(1, quantity || 1)
      };

      if (data.useCartProperties) {
        var properties = {};
        if (selection.color) {
          properties.Color = selection.color;
        }
        if (selection.size) {
          properties.Size = selection.size;
        }
        if (Object.keys(properties).length) {
          item.properties = properties;
        }
      }

      return item;
    }

    function setAddingState(isAdding) {
      adding = isAdding;
      updateActionButtons();
    }

    function openCartDrawer() {
      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer && cartDrawer.showModal) {
        cartDrawer.showModal();
      }
    }

    function addToCart(quantity) {
      if (adding || !canAddToCart()) {
        return;
      }

      var item = buildCartItem(quantity);
      if (!item) {
        return;
      }

      setAddingState(true);

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('add failed');
          }
          return response.json();
        })
        .then(function () {
          if (quantityInput) {
            quantityInput.value = '1';
          }
          if (typeof window.refreshCartDrawer === 'function') {
            return window.refreshCartDrawer();
          }
        })
        .then(function () {
          openCartDrawer();
        })
        .catch(function () {
          /* allow retry */
        })
        .finally(function () {
          setAddingState(false);
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      addToCart(qty);
    });

    form.addEventListener('click', function (event) {
      var colourBtn = event.target.closest('[data-product-colour]');
      if (colourBtn) {
        event.preventDefault();
        selection.color = colourBtn.getAttribute('data-value');
        applySelection({ scrollMedia: true });
        paintSwatches();
        return;
      }

      var sizeBtn = event.target.closest('[data-product-size]');
      if (sizeBtn) {
        event.preventDefault();
        if (sizeBtn.disabled) {
          return;
        }
        selection.size = sizeBtn.getAttribute('data-value');
        applySelection();
        setSizePanelOpen(false);
        return;
      }

      var sizeToggleBtn = event.target.closest('[data-product-size-toggle]');
      if (sizeToggleBtn) {
        event.preventDefault();
        if (sizePanel) {
          setSizePanelOpen(sizePanel.hidden);
        }
        return;
      }

      var plus = event.target.closest('[data-product-quantity-plus]');
      if (plus) {
        event.preventDefault();
        if (!plus.disabled) {
          addToCart(1);
        }
        return;
      }

      var trigger = event.target.closest('[data-product-accordion-trigger]');
      if (trigger) {
        event.preventDefault();
        var item = trigger.closest('[data-product-accordion-item]');
        var panel = item ? item.querySelector('[data-product-accordion-panel]') : null;
        if (!panel) {
          return;
        }

        var isOpen = trigger.classList.contains('is-active');
        if (isOpen) {
          trigger.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          trigger.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      }
    });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductPage);
    } else {
      initProductPage();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-page"]) return;
  try {
    
  (function () {
    var content = document.querySelector('.store-page__content');
    if (!content) {
      return;
    }

    content.querySelectorAll('[style]').forEach(function (el) {
      el.removeAttribute('style');
    });

    content.querySelectorAll('font').forEach(function (fontEl) {
      var span = document.createElement('span');
      while (fontEl.firstChild) {
        span.appendChild(fontEl.firstChild);
      }
      fontEl.replaceWith(span);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
